import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import { Position } from "../../../api/models";
import { PagedApiState } from "../../../api/useApiState";
import "../../../styles/card.scss";
import { BaseDrawer } from "../../BaseDrawer";
import { DownloadOperationRun } from "../../DownloadOperationRun";
import { SelectedOperationRun } from "../../details/SCBOneDetails";
import { PositionTable } from "./PositionTable";

interface OperationRunPositionsDrawerProps {
  operationRun: SelectedOperationRun | undefined;
  paginatedOperationRunPositions: PagedApiState<Position>;
  allOperationRunPositions: Position[];
  allOperationRunPositionsLoading: boolean;
  isLoading: boolean;
  operationRunPosDrawerVisible: boolean;
  onCloseDrawer: (visible: boolean) => void;
}

export function OperationRunPositionsDrawer({
  operationRun,
  paginatedOperationRunPositions,
  allOperationRunPositions,
  allOperationRunPositionsLoading,
  isLoading,
  operationRunPosDrawerVisible,
  onCloseDrawer,
}: OperationRunPositionsDrawerProps) {
  const { t } = useTranslation();

  if (operationRun) {
    return (
      <BaseDrawer
        title={t("scb-one:operation-run-positions-title")}
        drawerVisible={operationRunPosDrawerVisible}
        onCloseDrawer={() => onCloseDrawer(false)}
        dataTestId="beacon-operation-run-positions-drawer"
      >
        <PositionTable
          positions={paginatedOperationRunPositions}
          isLoading={isLoading}
          visibleColumns={[
            "ts",
            "lat",
            "lon",
            "hAcc",
            "vAcc",
            "alt",
            "sats",
            "cprs",
          ]}
          style={{ marginBottom: 50 }}
        />
        <DownloadOperationRun
          from={operationRun?.startDate}
          to={operationRun?.startDate}
          runId={operationRun?.runId}
          positions={allOperationRunPositions}
          loading={allOperationRunPositionsLoading}
          disabled={
            allOperationRunPositionsLoading ||
            allOperationRunPositions.length === 0
          }
          style={{ position: "absolute", bottom: 10, right: 40 }}
        />
      </BaseDrawer>
    );
  } else {
    return (
      <BaseDrawer
        title={t("scb-one:operation-run-positions-title")}
        drawerVisible={operationRunPosDrawerVisible}
        onCloseDrawer={() => onCloseDrawer(false)}
        dataTestId="beacon-operation-run-positions-drawer"
      >
        <Alert
          message={t("scb-one:run-notification-select")}
          type="info"
          showIcon
        />
      </BaseDrawer>
    );
  }
}

interface BeaconPositionDrawerProps {
  positions: PagedApiState<Position>;
  drawerVisible: boolean;
  onCloseDrawer: (visible: boolean) => void;
}
export function BeaconPositionDrawer({positions, drawerVisible, onCloseDrawer}: BeaconPositionDrawerProps) {
  const { t } = useTranslation();
  return (
    <BaseDrawer
      title={t("positions")}
      drawerVisible={drawerVisible}
      onCloseDrawer={() => onCloseDrawer(false)}
      dataTestId="beacon-operation-run-positions-drawer"
    >
      <PositionTable
        positions={positions}
        isLoading={positions.loading}
        visibleColumns={[
          "ts",
          "lat",
          "lon",
          "hAcc",
          "vAcc",
          "alt",
          "sats",
          "cprs",
        ]}
        style={{ marginBottom: 50 }}
      />
    </BaseDrawer>
  );
}
